module.exports = __webpack_public_path__ + "static/media/file-rtf.c655c831.svg";